import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreateAdvertisementRoutingModule } from './create-advertisement-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CreateAdvertisementRoutingModule
  ]
})
export class CreateAdvertisementModule { }
